'use client';

import { c as _c } from "react/compiler-runtime";
import { Typography } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
import { Icon } from "@/shared/ui/atoms";
import Image from "next/image";
import Link from "next/link";
import { TreatmentCaseDetailResponse } from "@/shared/types/type/treatment";
import { DirectionIcon, IconButton } from "@/shared/ui/atoms";
import { useParams, useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { useMutationTreatmentCaseHelpful, useMutationTreatmentCaseHelpfulDelete } from "@/entities/treatment-case/hooks/useTreatment";
import { registerTreatmentCaseViewClient } from "@/entities/treatment-case/api/treatment-case.client";
import { Loading } from "@/shared/ui/organisms";
import { useLocale, useTranslations } from "next-intl";
import { useAuthContext } from "@/app/providers/AuthProviders";
import { toTreatmentCaseBodyHtml } from "@/entities/treatment-case/lib/seo";
import { toIsoSeoDate } from "@/shared/lib/seo-date";
import { buildHospitalShortPath } from "@/entities/hospital/lib/detail-route";
interface TreatmentCaseDetailTemplatesProps {
  detail: TreatmentCaseDetailResponse;
}
const TreatmentCaseDetailTemplates = t0 => {
  const $ = _c(77);
  const {
    detail
  } = t0;
  const t = useTranslations();
  const locale = useLocale();
  const router = useRouter();
  const {
    id
  } = useParams() as {
    id: string;
  };
  const {
    loggedIn
  } = useAuthContext();
  const {
    mutate
  } = useMutationTreatmentCaseHelpful();
  const {
    mutate: deleteHelpful
  } = useMutationTreatmentCaseHelpfulDelete();
  const {
    treatmentSubjectName,
    title,
    createdAt,
    viewCount,
    hospitalOriginId,
    hospitalOriginName,
    hospitalFullAddress,
    hospitalThumbnailUrl,
    content,
    isHelpful
  } = detail;
  const [isDisplayHelpfulButton, setIsDisplayHelpfulButton] = useState(isHelpful);
  const [isLoading, setIsLoading] = useState(false);
  let t1;
  if ($[0] !== createdAt) {
    t1 = toIsoSeoDate(createdAt);
    $[0] = createdAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const machineReadableCreatedAt = t1;
  const viewRegisteredRef = useRef(false);
  let t2;
  let t3;
  if ($[2] !== id) {
    t2 = () => {
      if (viewRegisteredRef.current) {
        return;
      }
      viewRegisteredRef.current = true;
      registerTreatmentCaseViewClient(Number(id)).catch(_temp);
    };
    t3 = [id];
    $[2] = id;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setTimeout(() => {
        setIsLoading(true);
      }, 100);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleHospitalInfoClick = t4;
  let t5;
  if ($[6] !== deleteHelpful || $[7] !== id || $[8] !== isDisplayHelpfulButton || $[9] !== locale || $[10] !== loggedIn || $[11] !== mutate || $[12] !== router) {
    t5 = () => {
      if (!loggedIn) {
        return router.push(`/${locale}/sign-in?redirect=/${locale}/treatment-case/${id}`);
      }
      if (isDisplayHelpfulButton) {
        deleteHelpful(Number(id));
      } else {
        mutate(Number(id));
      }
      setIsDisplayHelpfulButton(!isDisplayHelpfulButton);
    };
    $[6] = deleteHelpful;
    $[7] = id;
    $[8] = isDisplayHelpfulButton;
    $[9] = locale;
    $[10] = loggedIn;
    $[11] = mutate;
    $[12] = router;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const handleHelpful = t5;
  const scrollToTop = _temp2;
  let t6;
  if ($[14] !== treatmentSubjectName) {
    t6 = <Typography size={14} lineHeight={22} className="text-primary-600 font-medium">{treatmentSubjectName}</Typography>;
    $[14] = treatmentSubjectName;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== title) {
    t7 = <Typography as="h1" size={20} lineHeight={28} className="mt-1 text-gray-900 font-semibold">{title}</Typography>;
    $[16] = title;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== createdAt || $[19] !== machineReadableCreatedAt) {
    t8 = <time dateTime={machineReadableCreatedAt} className="text-[14px] leading-[22px] tracking-[-0.28px] text-gray-400">{createdAt}</time>;
    $[18] = createdAt;
    $[19] = machineReadableCreatedAt;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="w-[2px] h-[2px] bg-gray-200 rounded-full my-auto" />;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== viewCount) {
    t10 = <Typography size={14} lineHeight={22} className="text-gray-400 tracking-[-0.28px]">조회수 {viewCount}</Typography>;
    $[22] = viewCount;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t8) {
    t11 = <div className="mt-2.5 flex items-center gap-1.5">{t8}{t9}{t10}</div>;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== hospitalOriginId || $[28] !== locale) {
    t12 = buildHospitalShortPath(locale, hospitalOriginId);
    $[27] = hospitalOriginId;
    $[28] = locale;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== hospitalThumbnailUrl) {
    t13 = <div className="flex-shrink-0 relative w-8 h-8 overflow-hidden rounded-full bg-gray-200"><Image src={hospitalThumbnailUrl} alt={"\uBCD1\uC6D0 \uB85C\uACE0"} fill={true} sizes="32px" className="object-cover" /></div>;
    $[30] = hospitalThumbnailUrl;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== hospitalOriginName) {
    t14 = <Typography size={16} lineHeight={22} className="text-gray-800 font-semibold text-start">{hospitalOriginName}</Typography>;
    $[32] = hospitalOriginName;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== hospitalFullAddress) {
    t15 = <Typography size={14} lineHeight={18} className="text-gray-600 text-start">{hospitalFullAddress}</Typography>;
    $[34] = hospitalFullAddress;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t14 || $[37] !== t15) {
    t16 = <div>{t14}{t15}</div>;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t13 || $[40] !== t16) {
    t17 = <div className="flex items-center gap-2">{t13}{t16}</div>;
    $[39] = t13;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <DirectionIcon size={20} className="text-gray-600" rotate={270} strokeWidth="1.5" />;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t12 || $[44] !== t17) {
    t19 = <Link href={t12} onClick={handleHospitalInfoClick} className="mt-5 flex items-center justify-between w-full py-2 px-4 rounded-lg bg-gray-100">{t17}{t18}</Link>;
    $[43] = t12;
    $[44] = t17;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="w-full h-[1px] bg-gray-100 my-2" />;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t11 || $[48] !== t19 || $[49] !== t6 || $[50] !== t7) {
    t21 = <div className="flex flex-col justify-center px-4 pt-6 pb-2">{t6}{t7}{t11}{t19}{t20}</div>;
    $[47] = t11;
    $[48] = t19;
    $[49] = t6;
    $[50] = t7;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== content) {
    t22 = toTreatmentCaseBodyHtml(content);
    $[52] = content;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t22) {
    t23 = <div id="medicontent" dangerouslySetInnerHTML={{
      __html: t22
    }} />;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t) {
    t24 = t("helpful");
    $[56] = t;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== t24) {
    t25 = <Typography size={14} lineHeight={22} className="text-gray-600 font-medium">{t24}</Typography>;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  const t26 = `/icons/thumbs-up${isDisplayHelpfulButton ? "-fill" : ""}.png`;
  const t27 = isDisplayHelpfulButton ? "animate-pop-150" : "";
  let t28;
  if ($[60] !== t26 || $[61] !== t27) {
    t28 = <Icon src={t26} width={16} height={16} alt="thumb" className={t27} />;
    $[60] = t26;
    $[61] = t27;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== handleHelpful || $[64] !== t25 || $[65] !== t28) {
    t29 = <CustomButton className="flex items-center gap-1 py-1.5 px-3 border border-gray-200 rounded-full" onClick={handleHelpful}>{t25}{t28}</CustomButton>;
    $[63] = handleHelpful;
    $[64] = t25;
    $[65] = t28;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <IconButton onClick={scrollToTop}><DirectionIcon size={24} className="text-gray-600" rotate={180} /></IconButton>;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t29) {
    t31 = <div className="flex items-center justify-between px-5 pt-[14px] pb-[18px] bg-white border-t border-gray-100">{t29}{t30}</div>;
    $[68] = t29;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] !== isLoading) {
    t32 = isLoading && <Loading />;
    $[70] = isLoading;
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  let t33;
  if ($[72] !== t21 || $[73] !== t23 || $[74] !== t31 || $[75] !== t32) {
    t33 = <section className="flex-1 flex flex-col bg-white border-t border-gray-100">{t21}{t23}{t31}{t32}</section>;
    $[72] = t21;
    $[73] = t23;
    $[74] = t31;
    $[75] = t32;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  return t33;
};
export default TreatmentCaseDetailTemplates;
function _temp() {}
function _temp2() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}